<template>
  <div>
    <playMusic :bar='play' ></playMusic>
    <div class="list">
    <div class="list-box-title">更多歌曲</div>
    <div class="list-box">
      <div class="list-box-item" v-for="(item,index) in list" :key="index" @click="playClick(item.id)" @mouseover="mouseOver(index)"
      @mouseleave="mouseLeave" :class="highlight==index?'active':''">
        <div class="item-img" ><img :src="item.src" alt=""></div>
        <div class="item-title">{{item.title}}</div>
        <div class="item-author">{{item.author}}</div>
      </div>
      <div class="list-box-item">
      </div>
      <div class="list-box-item">
      </div>
      <div class="list-box-item">
      </div>
      <div class="list-box-item">
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return {
      list:[
        {
          id: 0,
          src:require('@/assets/imgs/music-right1.png'),
          title:'送春',
          author:'王晓慧'
        },
        {
          id: 1,
          src:require('@/assets/imgs/music-right2.png'),
          title:'萤火',
          author:'王晓慧'
        },
        {
          id: 2,
          src:require('@/assets/imgs/music-right3.png'),
          title:'雨晴',
          author:'王晓慧'
        },
        {
          id: 3,
          src:require('@/assets/imgs/music-right4.png'),
          title:'燕歌行',
          author:'王晓慧'
        },
        {
          id: 4,
          src:require('@/assets/imgs/music-right5.png'),
          title:'跋涉者',
          author:'邓金晶'
        },
        {
          id: 5,
          src:require('@/assets/imgs/music-right6.png'),
          title:'成就梦想',
          author:'解放'
        },
        {
          id: 6,
          src:require('@/assets/imgs/list1 (1).png'),
          title:'幸福就在眼前',
          author:'程伟'
        },
        {
          id: 7,
          src:require('@/assets/imgs/list1 (3).png'),
          title:'心里面的思念',
          author:'程伟'
        },
        {
          id: 8,
          src:require('@/assets/imgs/list1 (4).png'),
          title:'走过千山万水',
          author:'程伟'
        },
        {
          id: 9,
          src:require('@/assets/imgs/list1 (2).png'),
          title:'真的不后悔',
          author:'程伟'
        }
      ],
      play: 0,
      highlight: -1,
    }
  },
  methods: {
    playClick(id) {
      this.play = id
    },
    mouseOver(index) {
      this.highlight = index
    },
    mouseLeave() {
      this.highlight = -1
    }
  },
}
</script>

<style scoped>

.list {
  width: 100%;
  height: 100%;
  padding: 0 360px;
}
.list-box-title {
  font-size: 24PX;
  line-height: 59px;
  border-bottom: 2px #BAA364 solid;
  margin-bottom: 30px;
}
.list-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
img {
  width: 100%;
  height: 100%;
}
.list-box-item {
  width: 16%;
  margin-bottom: 20px;
}
.item-img {
  width: 100%;
  height: 178px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}
.active {
  margin-top: -20px;
}
.item-title {
  font-size: 18PX;
  line-height: 30px;
  text-indent: 1rem;
}
.item-author {
  font-size: 14PX;
  line-height: 30px;
  text-indent: 1rem;
}
</style>
